const LeadConstants = {
    LEADS_FOR_LISTING: {
        FEED_ID: '',
        FEED_LISTING_ID: '',
        START: 0,
        LIMIT: 20,
    },
};

export default LeadConstants;
